import React, { useContext } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { formatPhoneNumber } from 'Utilities/helpers';

import { FiguresBox } from '../components/FiguresBox/FiguresBox';
import { PHONES } from '../Payments.helpers';
import LocalTexts from '../Payments.text.json';
import { PaymentViewProps } from '../Payments.types';
import { PaymentContext } from '../PaymentsContext';

const LocalT = new MDText(LocalTexts.payments.declineView);

const PaymentDecline = ({ actions }: PaymentViewProps) => {
  const { paymentState: { dealerName } } = useContext(PaymentContext);

  return (
    <div>
      <FiguresBox
        buttons={
          <>
            <Button
              reverse
              as="a"
              href={`tel:${PHONES.CONTACT_US_PAGE_FOR_SELLERS}`}
              icon="phone"
              label={`${formatPhoneNumber(PHONES.CONTACT_US_PAGE_FOR_SELLERS).pretty}`}
            />
            <Button
              fullWidth
              label={`${LocalT.translate('buttons.back')}`}
              onClick={actions.showEnterView}
              variant="secondary"
            />
          </>
        }
        content={
          <p>{LocalT.translate('text')}</p>
        }
        title={`${LocalT.translate('title', { dealer: dealerName })}`}
      />
    </div>
  );
};

export { PaymentDecline };
